<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled mjesečnog statusa zaposlenih</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Sektor -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label">Sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="seletedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <div
        class="reports"
        v-for="employee in employees"
        v-bind:key="employee.employeeId"
      >
        <monthly-status-table
          :employee="employee"
          :month="selectedMonth"
          :year="selectedYear"
        ></monthly-status-table>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
// import ReportService from "../../services/report.service";
// import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import MonthlyStatusTable from "../parts/MonthlyStatusTable.vue";
//import //   getDateFromTicks,
//   maskIfEquealsValue,
//   isWorkingDayFromDate,
//"../../_helpers/arrangers";

// const colors = [
//   "#363636",
//   "#046FDB",
//   "#F85252",
//   "#8B54E4",
//   "#F07B3B",
//   "#3ba272",
// ];

export default {
  name: "MonthlyStatus",
  components: {
    // VueTableDynamic,
    DatePicker,
    MonthlyStatusTable,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      departments: [],
      seletedDepartment: null,
      employees: [],
      departmentData: null,
      selectedMonth: null,
      selectedYear: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
    this.getDepartments();
  },
  methods: {
    tableCellClicked() {},
    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        this.departmentData = response.data;
        console.log("dafaq");
        console.log(this.departmentData);
        this.arrangeSectors(response.data);
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    // getData() {
    //   ReportService.GetMonthlyPresenceReviewByEmployeeIdAndMonth();
    // },
    departmentSelected() {
      console.log("dafaqa");
      console.log(this.seletedDepartment);
      let departmentId = this.seletedDepartment.id;

      this.employees = this.departmentData.find((d) => {
        return d.departmentId === departmentId;
      }).employee;

      console.log(this.employees);
    },
  },
};
</script>